<template>
	<multiselect
		:value="value"
		placeholder="Input or Select Tag"
		label="name"
		track-by="name"
		:options="options"
		:show-labels="false"
		:allow-empty="true"
		:multiple="true"
		:taggable="true"
		:hide-selected="true"
		@tag="addTag"
		@select="onSelect"
		@remove="onRemove"
		@search-change="onSearch">
		<template slot="maxElements">
			<span>{{ $t('global.maxSelectedTag') }}</span>
		</template>
		<template slot="beforeList">
			<div class="p-4" v-if="isFetching">
				<div class="is-loading dark"></div>
			</div>
		</template>
		<template slot="afterList">
			<div class="select-loadmore" @click="fetch(false)" v-if="hasNextPage">Load More</div>
		</template>
	</multiselect>
</template>

<script>
import { delay } from '../lib/helper';
import tagsApi from '../api/tag';

export default {
	name: 'TagsSelect',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		category: {
			type: String,
			default: 'order',
		},
	},
	data() {
		return {
			options: [],
			page: 1,
			limit: 20,
			keyword: '',
			isFetching: false,
			hasNextPage: false,
		};
	},
	methods: {
		fetch(reset = false) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.options = [];
			}
			const keyword = this.keyword.trim();
			const params = {
				page: this.page,
				limit: this.limit,
				category: this.category,
				sort_by: 'name',
				sort: 'desc',
			};
			if (keyword !== '') {
				params.keyword = keyword;
			}
			const callback = (response) => {
				const tags = response.data;
				this.hasNextPage = tags.length === this.limit;
				this.appendOptions(tags);
				this.page++;
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			tagsApi.getTags(params, callback, errorCallback);
		},
		appendOptions(tags) {
			for (let index = 0; index < tags.length; index++) {
				const tag = tags[index];
				this.options.push(tag);
			}
		},
		onSelect(selected) {
			const selectedTags = this.value;
			selectedTags.push(selected);
			this.$emit('input', selectedTags);
		},
		reachedEndOfList(reached) {
			if (reached) {
				this.fetch();
			}
		},
		addTag(keyword) {
			const tagName = keyword.trim();
			const tag = {
				name: tagName,
			};
			this.onSelect(tag);
			this.$emit('add', tagName);
		},
		onRemove(tag) {
			const selectedTags = this.value;
			const index = selectedTags.findIndex(({ name }) => name === tag.name);
			if (index !== -1) {
				selectedTags.splice(index, 1);
			}
			this.$emit('input', selectedTags);
		},
		onSearch(keyword) {
			delay(() => {
				this.keyword = keyword;
				this.fetch(true);
			}, 500);
		},
	},
	created() {
		this.fetch();
	},
};
</script>
